import { Association } from "./association";
import { Permission } from "./permission";
import { Role } from "./role";
import { Shipper } from "./shipper";

export interface UserContract {
    associations: Association[];
    auth0Id: string;
    createdOn: Date;
    email: string;
    firstName: string;
    id: number;
    lastModified: Date;
    lastName: string;
    permissions: Permission[];
    roles: Role[];
    shippers: Shipper[];
}

export class User implements UserContract {
    associations: Association[] = [];
    auth0Id: string = '';
    createdOn: Date = new Date();
    email: string = '';
    firstName: string = '';
    id: number = 0;
    lastModified: Date = new Date();
    lastName: string = '';
    permissions: Permission[] = [];
    roles: Role[] = [];
    shippers: Shipper[] = [];

    hasPermission(systemName: string) {
        return this.permissions.some(permission => permission.systemName === systemName);
    }
}
